<template>
  <Modal :show="true" centered size="xl" title="Liquidación de Privados" @hide="$emit('hide')" body-class="p-0">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <div class="card-body">
        <div class="row align-items-center mb-3">
          <div class="col-12 col-lg mb-3 mb-sm-0">
            <p class="mb-1"><strong>Agencia: </strong>{{ modalItem.agencia }}</p>
            <ul class="list-inline mb-0">
              <li class="list-inline-item"><strong>Código:</strong> {{ modalItem.codigo }}</li>
              <li class="list-inline-item"><strong>Pasajero:</strong> {{ modalItem.pasajero }}</li>
              <li class="list-inline-item"><strong>Idioma:</strong> {{ modalItem.idioma }}</li>
              <li class="list-inline-item"><strong>PAX:</strong> {{ modalItem.nroAdultos }}</li>
              <li class="list-inline-item" v-if="modalItem.nroNinos"><strong>CHD:</strong> {{ modalItem.nroNinos }}</li>
              <template v-if="estaLiquidado">
                <li class="list-inline-item"><strong>Fecha Liquidación:</strong> {{ liquidado.fechaLiquidacion | date }}</li>
              </template>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <div class="text-sm-right">
              <button v-if="!estaLiquidado" @click="onLiquidar" class="btn btn-sm btn-primary" :disabled="loading.save || estaLiquidado">
                Liquidar
              </button>
              <router-link v-else :to="{ name: 'liquidaciones', query: { codRegistro: modalItem.codigo } }" class="btn btn-sm btn-outline-success">
                Ver Liquidación
              </router-link>
              <button @click="onPrint" class="btn btn-sm btn-outline-secondary ml-2">
                Imprimir
              </button>
            </div>
          </div>
        </div>
      </div>
      <ValidationObserver ref="formTable">
        <PrivadoLiquidarTable></PrivadoLiquidarTable>
      </ValidationObserver>
    </template>
  </Modal>
</template>

<script>
import PrivadoLiquidarTable from "./PrivadoLiquidarTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";
import { mapGetters, mapState } from "vuex";
import pdfPrivadoLiquidacion from "@/pdfs/pdfPrivadoLiquidacion";

export default {
  components: { Modal, Spinner, PrivadoLiquidarTable },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    modalItem: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        view: true,
        save: false,
      },
    };
  },
  async created() {
    let vm = this;
    let response;

    try {
      response = await vm.axios.get(`/privados/${vm.modalItem.idPrivado}/liquidacion`);
    } catch (error) {
      return;
    }

    const listArr = response.data.content.registros.map((item, index) => ({
      ...item,
      id: index + 1,
      tarifa: Number(item.tarifa).toFixed(2),
      observaciones: response.data.content.liquidado ? item.observaciones : "",
      isNew: false,
      tempMoneda: item.moneda || "USD",
    }));

    vm.$store.commit("privado.liquidar/load", {
      list: listArr,
      liquidado: response.data.content.liquidado,
      monedas: response.data.content.monedas,
    });

    vm.loading.view = false;
  },
  computed: {
    ...mapGetters("privado.liquidar", ["total", "estaLiquidado", "monedas"]),
    ...mapState("privado.liquidar", {
      listArr: "list",
      liquidado: "liquidado",
    }),
  },
  methods: {
    async onLiquidar() {
      const vm = this;

      const success = await vm.$refs.formTable.validate();
      if (!success) {
        vm.$toast.fire("", "Completa los campos requeridos", "warning");
        return;
      }

      const id_por_moneda = vm.monedas.reduce((obj, item) => {
        obj[item.sigla] = item.idMoneda;
        return obj;
      }, {});

      const list = [...vm.listArr].map((item) => {
        return {
          ...item,
          idMoneda: id_por_moneda[item.tempMoneda],
        };
      });

      vm.loading.save = true;

      vm.axios
        .post(`/privados/${vm.modalItem.idPrivado}/liquidacion`, {
          items: list,
          total: vm.total,
        })
        .then((response) => {
          console.log(response.data.content);

          vm.$store.dispatch("privado.liquidar/save", response.data.content);
          vm.$toast.fire(response.data.message, "", "success");
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onPrint() {
      const vm = this;

      const items = vm.listArr.map((item) => ({
        fecha: item.fecha ? vm.$dayjs(item.fecha, "YYYY-MM-DD").format("DD-MM-YY") : "",
        servicio: item.servicio || item?.otroServicio || "",
        hotel: item.hotel || item?.otroHotel || "",
        servicioTipo: item.servicioTipo || item?.otroTipo || "",
        moneda: vm.estaLiquidado ? item.moneda : item.tempMoneda,
        tarifa: {
          alignment: "center",
          text: item.tarifa ? Number(item.tarifa).toFixed(2) : "0.00",
        },
        observaciones: item.observaciones || "",
      }));

      Object.keys(vm.total).forEach((moneda) => {
        items.push({
          fecha: {
            colSpan: 5,
            alignment: "right",
            text: `TOTAL ${moneda}`,
          },
          servicio: "",
          hotel: "",
          servicioTipo: "",
          tarifa: {
            alignment: "center",
            text: Number(vm.total[moneda]).toFixed(2),
          },
          observaciones: "",
        });
      });


      pdfPrivadoLiquidacion({
        items,
        header: {
          agencia: vm.modalItem.agencia,
          codigo: vm.modalItem.codigo,
          pasajero: vm.modalItem.pasajero,
          idioma: vm.modalItem.idioma,
          pax: vm.modalItem.nroAdultos,
          chd: vm.modalItem.nroNinos || "",
          fechaLiquidacion: vm.estaLiquidado ? vm.$dayjs(vm.liquidado[2]).format("DD-MM-YY") : "",
        },
        preview: !vm.estaLiquidado,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
